import { render, staticRenderFns } from "./UserAppMapping.vue?vue&type=template&id=0a4fc5e4&scoped=true&"
import script from "./UserAppMapping.vue?vue&type=script&lang=js&"
export * from "./UserAppMapping.vue?vue&type=script&lang=js&"
import style0 from "./UserAppMapping.vue?vue&type=style&index=0&id=0a4fc5e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4fc5e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCheckbox,VSimpleTable})
